import React, {useMemo, useState} from 'react';

const GlobalDataContext = React.createContext({});

// @ts-ignore
const GlobalDataContextProvider = ({ children }) => {
    const [reportsAvailables, setReportsAvailables] = useState<{}>({});
    const [last10YearReports, setLast10YearReports] = useState<{}>({});
    const [lastYearAvailable, setLastYearAvailable] = useState<{}>({});
    const [bpsData, setBpsData] = useState<{}>({});
    const [allDataLoaded, setAllDataLoaded] = useState<boolean>(false);

    const setData = (reportsAvailables: any, last10YearReports: any, lastYearAvailable: any, bpsData: any) => {
        setReportsAvailables(reportsAvailables);
        setLast10YearReports(last10YearReports);
        setLastYearAvailable(lastYearAvailable);
        setBpsData(bpsData);
        
        setAllDataLoaded(true);
    };

    const value = useMemo(
        () => ({reportsAvailables, last10YearReports, lastYearAvailable, bpsData, setData, allDataLoaded}),
        [reportsAvailables, last10YearReports, lastYearAvailable, bpsData, allDataLoaded]
    );

    return (
        <GlobalDataContext.Provider value={value}>
            {children}
        </GlobalDataContext.Provider>
    );
};

export {
    GlobalDataContextProvider,
    GlobalDataContext,
}
